import { Button } from '@120wateraudit/envirio-components'
import { Maybe } from 'generated/graphql'
import React from 'react'
import styled from 'styled-components'

import useAccount from 'hooks/useAccount'
import { useHistory } from 'react-router-dom'
import formatDate from 'utils/formatDate'

interface Props {
  locationId?: number
  privateMaterialColor?: string
  privateName?: Maybe<string>
  privateVerifiedDate?: Maybe<string>
  publicMaterialColor?: string
  publicName?: Maybe<string>
  publicVerifiedDate?: Maybe<string>
  title?: Maybe<string>
}

const MarkerPopup = (props: Props) => {
  const { hideServiceLines } = useAccount()
  const {
    locationId,
    privateMaterialColor,
    privateName,
    privateVerifiedDate,
    publicMaterialColor,
    publicName,
    publicVerifiedDate,
    title
  } = props
  const { accountUrl, ptdSettings } = useAccount()

  const history = useHistory()
  const { systemOwnedName, customerOwnedName } = ptdSettings

  return (
    <Wrapper>
      <div>
        <MainHeader underline="underline">{`${title}`}</MainHeader>
        {!hideServiceLines && (
          <>
            <StyledInfoSection>
              <SubHeader style={{ textAlign: 'left' }}>
                {systemOwnedName ? systemOwnedName : 'System-Owned Material'}
              </SubHeader>
              <Text
                style={{ textAlign: publicName ? 'center' : 'right' }}
                color={publicMaterialColor}>
                {publicName ? publicName : '--'}
              </Text>
            </StyledInfoSection>
            <StyledInfoSection>
              <SubHeader style={{ textAlign: 'left' }}>
                {customerOwnedName
                  ? customerOwnedName
                  : 'Customer-Owned Material'}
              </SubHeader>
              <Text
                style={{ textAlign: privateName ? 'center' : 'right' }}
                color={privateMaterialColor}>
                {privateName ? privateName : '--'}
              </Text>
            </StyledInfoSection>
            <VerifiedInfoSection>
              <SubHeader style={{ textAlign: 'left' }}>
                {systemOwnedName
                  ? `${systemOwnedName} Verified`
                  : 'System-Owned Verified'}
              </SubHeader>
              <Text style={{ textAlign: 'right' }}>
                {publicVerifiedDate ? formatDate(publicVerifiedDate) : '--'}
              </Text>
            </VerifiedInfoSection>
            <VerifiedInfoSection>
              <SubHeader style={{ textAlign: 'left' }}>
                {customerOwnedName
                  ? `${customerOwnedName} Verified`
                  : 'Customer-Owned Verified'}
              </SubHeader>
              <Text style={{ textAlign: 'right' }}>
                {privateVerifiedDate ? formatDate(privateVerifiedDate) : '--'}
              </Text>
            </VerifiedInfoSection>
          </>
        )}
      </div>
      <Button
        onClick={() =>
          history.push(`/${accountUrl}/locationDetails/${locationId}`)
        }>
        View History
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 450px;
  height: 100%;
`

const SubHeader = styled.span`
  display: block;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
`

const MainHeader = styled.h5<{
  underline?: string
}>`
  margin: 10px 0;
  text-decoration: ${props => (props.underline ? props.underline : 'initial')};
`

const Text = styled.span<{
  color?: string
}>`
  color: ${props => (props.color ? props.color : 'initial')};
`

const StyledInfoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  line-height: 1;
`

const VerifiedInfoSection = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 0.5fr;
  line-height: 1;
`

export default MarkerPopup
